import { solicitar } from '../identidad/cliente-identidad.js'

export type EstadoSeguimiento = 'PENDIENTE' | 'VALIDADO' | 'RECHAZADO'
export interface RegistroSeguimiento {
  id: string
  expedienteId: string
  estudianteNombre: string
  revisorNombre: string
  estado: EstadoSeguimiento
  motivoRechazo: string | null
  decididoEn: string | null
  version: number
  creadoEn: string
  asunto?: string
  compromisoEstudiante?: string
  fecha?: string
  horas?: number
  actividad?: string
  analisisReflexivo?: string
}
export interface Notificacion {
  id: string
  tipo: string
  recursoTipo: string
  recursoId: string
  titulo: string
  mensaje: string
  leidaEn: string | null
  creadaEn: string
}

type Modulo = 'asesorias' | 'apoyos' | 'diarios'
export const listarSeguimiento = (expedienteId: string, modulo: Modulo) =>
  solicitar<{ datos: RegistroSeguimiento[] }>(`/api/v1/expedientes/${expedienteId}/${modulo}`)
export const crearSeguimiento = (expedienteId: string, modulo: Modulo, datos: object) =>
  solicitar<{ id: string }>(`/api/v1/expedientes/${expedienteId}/${modulo}`, {
    method: 'POST',
    body: JSON.stringify(datos),
  })
export const decidirSeguimiento = (
  modulo: Modulo,
  registro: Pick<RegistroSeguimiento, 'id' | 'version'>,
  decision: 'VALIDAR' | 'RECHAZAR',
  motivo?: string,
) =>
  solicitar<void>(`/api/v1/${modulo}/${registro.id}/decision`, {
    method: 'POST',
    body: JSON.stringify({ decision, version: registro.version, ...(motivo ? { motivo } : {}) }),
  })
export const listarNotificaciones = () =>
  solicitar<{ datos: Notificacion[] }>('/api/v1/notificaciones')
export const marcarNotificacionLeida = (id: string) =>
  solicitar<void>(`/api/v1/notificaciones/${id}/leida`, { method: 'POST' })
